export default __webpack_public_path__ + "static/media/Dermaheal.107e027b.png";